import React, { useEffect, useState } from "react";
import "./Bookings.css";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { BookingList } from "./BookingList";
import { useAppContext } from "../../libs/contextLib";
import ExpressBooking from "./ExpressBooking";
import { BookingProvider } from "./BookingContext";
import { BookingFilters } from "./BookingFilters";
import dayjs from "../../dayjs";

function Bookings() {

  const { setBreadcrumb, setPageTitle, isAdmin } = useAppContext();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const history = useHistory();

  useEffect(() => {
    setBreadcrumb("Bookings");
    setPageTitle("Bookings");
  }, [setBreadcrumb, setPageTitle]);

  const handleAddBooking = () => {
    const currentDate = dayjs();
    history.push(`/bookings/_new_?date=${currentDate.format('YYYY-MM-DD')}`);
  }

  return (
    <BookingProvider>
      <div className="bookings-container">
        <div className="d-flex align-items-center justify-content-between filter-options-main">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <Button 
              type="primary" 
              className="icon-button" 
              icon={<PlusOutlined />} 
              onClick={handleAddBooking}
            >
              Add Booking
            </Button>
            {isAdmin && <Button type="primary" className="icon-button" icon={<PlusOutlined />} onClick={() => setModalVisible(true)}>
              Add Quick Booking
            </Button>}
          </div>
          <BookingFilters />
        </div>
        <BookingList setDate={setSelectedDate} />
        {modalVisible && <ExpressBooking isModal={true} onClose={() => setModalVisible(false)} isOpen={modalVisible} /> }
        
      </div>
    </BookingProvider>
  );
}

export default Bookings;
